.ratings {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ratingButton {
  height: 64px;
}

@media all and (--reefer-media-tablet-min) {
  .ratings {
    flex-direction: row;
  }
}
